@if (separateDropdown) {

  <div class="dropdown-container">
    <div class="scheduled-exports-dropdown">
      <wm-common-dropdown
        [data]="scheduledExportDropdownData"
        (change)="onScheduledExportChange($event)"
      ></wm-common-dropdown>
    </div>
    <div class="exports-dropdown">
      <wm-common-dropdown
        [data]="exportsDropdown"
        (change)="onExportAction($event)"
      ></wm-common-dropdown>
    </div>
  </div>

} @else {

  <!-- DESKTOP EXPORT DROPDOWN -->
  <div class="export-dropdown mobile-export-btn">

    <wm-common-dropdown
      *ngIf="!isMobileView"
      [data]="exportMenuDropdownData"
      (change)="onExportMenuChange($event)"
    ></wm-common-dropdown>

  </div>

  <!-- MOBILE EXPORT BUTTON -->
  <div
    class="blue-export-btn"
    *ngIf="isMobileView"
    (click)="openExportDrawer()"
  >
    <span>EXPORTS</span>
    <mat-icon>keyboard_arrow_down</mat-icon>
  </div>

  <!-- MOBILE EXPORT DRAWER -->
  <div
    *ngIf="isExportDrawerOpen"
    #mobileExportDrawer
    class="mobile-drawer-overlay"
    (click)="closeExportDrawer()"
  >

    <div
      class="mobile-drawer-card"
      (click)="$event.stopPropagation()"
    >

      <!-- HEADER -->
      <div class="mobile-drawer-header">

        <div class="mobile-drawer-title">
          Exports
        </div>

        <div
          class="mobile-drawer-close"
          (click)="closeExportDrawer()"
        >
          <mat-icon>close</mat-icon>
        </div>

      </div>

      <!-- BODY -->
      <div class="mobile-drawer-body">

        <ng-container *ngFor="let option of exportMenuDropdownData?.options">
          <div *ngIf="option.isDivider" class="mobile-drawer-divider"></div>
          <div
            *ngIf="!option.isDivider"
            class="mobile-drawer-item"
            [class.disabled-item]="option.disabled"
            (click)="!option.disabled && onExportMenuChange(option.value); closeExportDrawer()"
          >
            {{ option.label }}
          </div>
        </ng-container>

      </div>

    </div>

  </div>

}

<!-- (change)="$event === 'NEW'
  ? openModalForNew()
  : openModalForExisting(getScheduledExportById($event))"
-->
